import { forwardRef } from 'react';

export const ChevronLeft = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M18.6666 24L20.5466 22.12L14.44 16L20.5466 9.88L18.6666 8L10.6666 16L18.6666 24Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
